import {postJSON} from './client';
import ValidationError from './ValidationError';

// TODO: Eliminate in favor graphql-hooks

interface GraphqlPayload {
  query: string | any;
  variables?: {};
  operationName?: string;
}

const query = async ({ query, variables, operationName }: GraphqlPayload) => {
  const response = await postJSON('/graphql', {
    query: query.loc ? query.loc.source.body : query, // handle string or grahql-tag loaded object
    variables,
    operationName
  });
  if (response.errors) {
    const message = response.errors.map(({message}) => message).join("\n");
    throw new ValidationError(message);
  }
  return response.data;
};

export default query;
